import { ClientData, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import Form from "common/Form/Form";
import { InputNumber } from "antd";
import Text from "common/Typography/Text";
import { DEMO_MAKER_FEE_INPUT_ID, DEMO_TAKER_FEE_INPUT_ID } from "testIds";

interface DemoFeeFieldsProps {
  account?: ClientData;
}

const DemoFeeFields = ({ account }: DemoFeeFieldsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const fields = ["demo_maker_fee", "demo_taker_fee"] as const;

  return (
    <>
      {fields.map((field) => (
        <Form.Item
          key={field}
          label={t(`create_account.${field}`)}
          name={field}
          initialValue={account?.[field] ?? null}
          normalize={(value: number | undefined) => value ?? null}
          rules={[
            {
              type: "number",
              min: 0,
              max: 5,
              message: t("create_account.demo_fee_error"),
            },
          ]}
        >
          <InputNumber
            step={0.01}
            controls={false}
            style={{ width: "100%" }}
            suffix="%"
            placeholder={t("create_account.exchange_fee")}
            data-testid={
              field === "demo_maker_fee"
                ? DEMO_MAKER_FEE_INPUT_ID
                : DEMO_TAKER_FEE_INPUT_ID
            }
          />
        </Form.Item>
      ))}
      <Text type="secondary" style={{ marginBottom: 16 }}>
        {t("create_account.demo_fees_help")}
      </Text>
    </>
  );
};

export default DemoFeeFields;
